import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n    border: 1px solid ",
        ";\n    overflow: hidden;\n\n    img {\n      object-fit: cover;\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import styled, { css, useTheme } from "styled-components";
import NextImage from "next/image";
import { Box, Desktop, Mobile, useWindowSize, prefixUrl } from "@miro-site/core";
var ImageWrapper = styled(Box).withConfig({
    componentId: "sc-d191b56c-0"
})(function(param) {
    var theme = param.theme;
    return css(_templateObject(), theme.colors.grey);
});
var CardImage = function(param) {
    var onShowCardDescription = param.onShowCardDescription, mobileImage = param.mobileImage, image = param.image, wrapperStyles = param.wrapperStyles, className = param.className, _priority = param.priority, priority = _priority === void 0 ? false : _priority;
    var theme = useTheme();
    var windowSize = useWindowSize();
    var isMobileViewPort = windowSize.width && windowSize.width < theme.breakpoints.small;
    if (!image.original.webp) {
        return null;
    }
    var getImages = function() {
        var placeholder = {
            placeholder: undefined,
            blurDataURL: undefined
        };
        if (!priority) {
            placeholder.placeholder = "blur";
            placeholder.blurDataURL = prefixUrl(image.placeholder.webp);
        }
        var desktopImageElement = /*#__PURE__*/ _jsx(NextImage, _object_spread({
            layout: "fill",
            src: prefixUrl(image.original.webp),
            unoptimized: true,
            alt: image.name,
            priority: priority
        }, placeholder));
        if (mobileImage) {
            desktopImageElement = /*#__PURE__*/ _jsx(Desktop, {
                children: desktopImageElement
            });
            if (!priority) {
                placeholder.blurDataURL = prefixUrl(mobileImage.placeholder.webp);
            }
            var mobileImageElement = /*#__PURE__*/ _jsx(Mobile, {
                children: /*#__PURE__*/ _jsx(NextImage, _object_spread({
                    layout: "fill",
                    src: prefixUrl(mobileImage.original.webp),
                    unoptimized: true,
                    alt: mobileImage.name,
                    priority: priority
                }, placeholder))
            });
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    desktopImageElement,
                    mobileImageElement
                ]
            });
        }
        return desktopImageElement;
    };
    return /*#__PURE__*/ _jsx(ImageWrapper, {
        className: className,
        $styles: wrapperStyles,
        onClick: function(e) {
            if (!isMobileViewPort) {
                return;
            }
            onShowCardDescription(e);
        },
        children: getImages()
    });
};
export default CardImage;
